import type { MenuOption } from 'naive-ui'
import { router } from '@/router'
import { staticRoutes } from '@/router/routes/static'
import { createMenus, createRoutes } from '@/utils/route'
import { local } from '@/utils/storage'

interface RoutesStatus {
  isInitAuthRoute: boolean
}
export const useRouteStore = defineStore('route-store', {
  state: (): RoutesStatus => {
    return {
      isInitAuthRoute: false,
    }
  },
  actions: {
    resetRouteStore() {
      this.resetRoutes()
      this.$reset()
    },
    resetRoutes() {
      if (router.hasRoute('/'))
        router.removeRoute('/')
    },

    async initRouteInfo() {
      // if (import.meta.env.VITE_AUTH_ROUTE_MODE === 'dynamic') {

      // }
      if (import.meta.env.VITE_AUTH_ROUTE_MODE === 'static') {
        return staticRoutes
      }
    },
    async initAuthRoute() {
      this.isInitAuthRoute = false
      const rowRoutes = await this.initRouteInfo()
      if (!rowRoutes) {
        window.$message?.error('获取路由失败，请稍后再试')
        return
      }
      const routes = createRoutes(rowRoutes)
      router.addRoute(routes)
      this.isInitAuthRoute = true
    },
  },
})
